export const DATE_FORMAT = 'MMM D, h:mm A'
